import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Row,
  Button,
  ButtonAlt,
} from './style';

import IntroCloudState from '../../states/IntroCloudState';

class IntroCloudFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { activeItem } = IntroCloudState;
    const { active } = this.props;
    const { isOpen } = this.state;

    return isOpen ? (
      <Wrapper active={!activeItem && !IntroCloudState.introActive}>
        <Row>
          {IntroCloudState.filterOptionsTrend.map((option, index) => (
            <Button
              className={IntroCloudState.activeFilterOptionsTrend.indexOf(option) === -1 ? 'inactive' : 'active'}
              key={index}
              onClick={evt => {
                evt.preventDefault();
                IntroCloudState.toggleFilter('Trend', option);
              }}
            >{option}</Button>
          ))}
        </Row>
        <Row>
          {IntroCloudState.filterOptionsMonth.map((option, index) => (
            <Button
            className={IntroCloudState.activeFilterOptionsMonth.indexOf(option) === -1 ? 'inactive' : 'active'}
            key={index}
              onClick={evt => {
                evt.preventDefault();
                IntroCloudState.toggleFilter('Month', option);
              }}
            >{option}</Button>
          ))}
        </Row>
        <Row>
          {/*
          <Button
            onClick={evt => {
              evt.preventDefault();
              this.setState({ isOpen: false });
            }}
          >Close</Button>
          */}
          <ButtonAlt
            onClick={evt => {
              evt.preventDefault();
              IntroCloudState.clearFilters();
              this.setState({ isOpen: false });
            }}
          >Clear</ButtonAlt>
        </Row>
      </Wrapper>
    ) : (
      <Wrapper active={!activeItem && !IntroCloudState.introActive}>
        <Row>
          <Button
            onClick={evt => {
              evt.preventDefault();
              this.setState({ isOpen: true });
            }}
          >Filter by: Trend, Month</Button>
        </Row>
      </Wrapper>
    );
  }
}

export default observer(IntroCloudFilter);



// WEBPACK FOOTER //
// ./src/components/IntroCloudFilter/index.js